var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 35,
    viewBox: "0 0 58 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1",
    d: "M40.4983 28.8462C46.6976 28.8462 51.7232 23.8207 51.7232 17.6214C51.7232 11.422 46.6976 6.39648 40.4983 6.39648C34.299 6.39648 29.2734 11.422 29.2734 17.6214C29.2734 23.8207 34.299 28.8462 40.4983 28.8462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M40.4953 33.2438C44.6385 33.2438 48.612 31.5979 51.5416 28.6682C54.4713 25.7386 56.1172 21.7651 56.1172 17.6219C56.1172 13.4787 54.4713 9.50521 51.5416 6.57554C48.612 3.64587 44.6385 2 40.4953 2H17.6219C15.5704 2 13.539 2.40407 11.6436 3.18915C9.74831 3.97422 8.02618 5.12492 6.57555 6.57554C5.12493 8.02617 3.97422 9.74831 3.18915 11.6436C2.40407 13.539 2 15.5704 2 17.6219C2 19.6734 2.40407 21.7048 3.18915 23.6001C3.97422 25.4955 5.12493 27.2176 6.57555 28.6682C8.02618 30.1189 9.74831 31.2695 11.6436 32.0546C13.539 32.8397 15.5704 33.2438 17.6219 33.2438H40.4953Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide);
export default __webpack_public_path__ + "static/media/slide.e45bd8c3433674ea59c3f2ed26da09e7.svg";
export { ForwardRef as ReactComponent };